module.exports = new __parcel__URL__("brickwarriors.4094d249.webp").toString();